export default "__VITE_ASSET__d2e8ac20__"